<template>
    <div class="ProgressCard">
        <div class="ProgressCard__in">
            <div class="ProgressCard__title">
                {{ data.valueText }}
            </div>
            <div class="ProgressCard__line">
                <div class="progressValue" :style="`width: ${data.value}%;`"></div>
            </div>
            <div class="ProgressCard__description" v-if="data.achievement&&data.value<100">
                <div>
                    <b>{{ data.achievement.title }}</b>
                    <span v-html="data.achievement.description"></span>
                </div>
                <div class="medal">
                    <img :src="`/local/templates/main/img/icons/rang-${data.achievement.rank}.svg`" alt="">
                </div>
            </div>
            <div class="ProgressCard__footer" v-if="data.value<100">
              {{data.achievement.bottomTExt}}

            </div>
        </div>
    </div>
</template>

<script>
// https://i.imgur.com/xETFRwf.png - reference

export default {
    name: "ProgressCard",
    props: ['data']
}
</script>

<style scoped lang="scss">
.ProgressCard {
    background-color: #fff;
    padding: rem(40) rem(25) 0;
    border-radius: rem(6);
    border: 1px solid var(--c-gray-700);

    &__title {
        font-weight: 600;
        font-size: rem(22);
        line-height: rem(28);
        margin-bottom: rem(20);
    }

    &__line {
        position: relative;
        height: rem(5);
        border-radius: rem(12);
        background-color: var(--c-gray-700);
        margin-bottom: rem(40);

        .progressValue {
            position: absolute;
            left: 0;
            top: 0;
            height: 100%;
            border-radius: rem(12);
            background-color: var(--c-primary-200);
            transition: width 1s;
        }
    }

    &__description {
        display: flex;
        padding-top: rem(35);
        font-weight: 400;
        font-size: rem(14);
        line-height: rem(20);
        padding-bottom: rem(25);
        border-top: 1px solid var(--c-gray-700);

        b {
            display: block;
            font-weight: 600;
            font-size: rem(16);
            line-height: rem(22);
            margin-bottom: rem(10);
        }

        .medal{
            width: rem(50);
            flex: 1 0 rem(50);
            margin-left: rem(50);
        }
    }

    &__footer {
        padding: rem(16) 0 rem(24);
        text-align: center;
        border-top: 1px solid var(--c-gray-700);
        font-weight: 600;
        font-size: rem(16);
        line-height: rem(22);
        margin-left: rem(-25);
        width: calc(100% + rem(50));
    }
}
</style>